<app-global-toaster *ngIf="globalToasterSerive.getToaster().show" />
<div
    class="tw-flex tw-justify-evenly sm:tw-p-6 tw-min-h-[100vh] tw-gap-5 sm:tw-bg-[#0A0A75] tw-bg-transparent tw-items-start sm:tw-items-center tw-relative"
>
    <div
        class="tw-w-full lg:tw-w-[60%] tw-pt-4 tw-pb-10 xl:tw-w-[40%] tw-bg-white tw-rounded-[24px] tw-flex tw-flex-col tw-relative tw-z-[2] tw-my-8 sm:tw-my-12"
    >
        <header class="tw-text-center">
            <div
                class="tw-flex tw-justify-between tw-items-center tw-min-h-[4rem] tw-px-8 md:tw-px-10"
            >
                <div class="tw-flex-1"></div>
                <img
                    ga-event-id="imsme_top_button_sp_click"
                    ga-event-category="Sign Up Page Button"
                    ga-event-label="IMSME Icon Home Button Top"
                    ga-track="track"
                    [routerLink]="['/home']"
                    src="/assets/images/logo/header_desktop.webp"
                    alt="IMSME Logo"
                    class="tw-cursor-pointer tw-h-auto tw-w-[35%] tw-mx-auto"
                />
                <div
                    class="tw-text-[16px] tw-font-medium tw-flex-1 tw-text-right"
                >
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('en')"
                    >
                        {{ "LANG.EN" | translate }}
                    </span>
                    |
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('bm')"
                    >
                        {{ "LANG.BM" | translate }}
                    </span>
                </div>
            </div>
        </header>
        <div class="tw-px-8 md:tw-px-16 tw-mt-2">
            <div
                class="tw-text-[24px] md:tw-text-[28px] tw-font-semibold tw-w-full"
            >
                {{ "COMMON.SIGNUP_MAIN" | translate }}
            </div>
        </div>
        <div class="tw-px-8 md:tw-px-16">
            <form
                [formGroup]="signUpForm"
                (ngSubmit)="onSubmitUserDetails()"
                class="tw-flex tw-flex-col"
            >
                <div class="tw-w-full">
                    <input-general
                        class="tw-block tw-mt-4 tw-w-[100%]"
                        [mandatoryField]="true"
                        [label]="'FORM.USERID' | translate"
                        [placeHolder]="'Mohd_Abu'"
                        [controlName]="'username'"
                        [errors]="
                            getErrors('username', 'FORM.USERID' | translate)
                        "
                    ></input-general>
                    <input-general
                        class="tw-block tw-mt-[20px] tw-w-[100%]"
                        [mandatoryField]="true"
                        [label]="'FORM.EMAIL' | translate"
                        [placeHolder]="'abc@gmail.com'"
                        [controlName]="'email'"
                        [errors]="getErrors('email', 'FORM.EMAIL' | translate)"
                    ></input-general>
                    <input-general
                        class="tw-block tw-mt-[20px] tw-w-[100%]"
                        [mandatoryField]="true"
                        [label]="'COMMON.MOBILE' | translate"
                        [placeHolder]="'XXXXX'"
                        [controlName]="'phoneNumber'"
                        [errors]="
                            getErrors(
                                'phoneNumber',
                                'COMMON.MOBILE' | translate
                            )
                        "
                        [phoneNoCodeLabel]="' +60 '"
                    ></input-general>
                    <div class="tw-relative tw-w-full">
                        <input-general
                            class="tw-block tw-mt-[20px] tw-w-[100%]"
                            [mandatoryField]="true"
                            [label]="'COMMON.PASSWORD' | translate"
                            [placeHolder]="'**********'"
                            [hideInput]="true"
                            [strength]="pswdStrength"
                            [strengthLabel]="pswdStrengthLabel"
                            [strengthColor]="pswdStrengthColor"
                            [controlName]="'password'"
                            [errors]="
                                getErrors(
                                    'password',
                                    'COMMON.PASSWORD' | translate
                                )
                            "
                            (keyup)="checkPasswordStatus($event)"
                        ></input-general>
                    </div>
                    <input-general
                        class="tw-block tw-w-[100%]"
                        [mandatoryField]="true"
                        [label]="'FORM.CONFIRM_PASSWORD' | translate"
                        [placeHolder]="'**********'"
                        [hideInput]="true"
                        [controlName]="'confirmPassword'"
                        [errors]="
                            getErrors(
                                'confirmPassword',
                                'FORM.CONFIRM_PASSWORD' | translate
                            )
                        "
                        (paste)="disablePaste($event)"
                    ></input-general>

                    <input-general
                        class="tw-block tw-mt-[20px] tw-w-[100%]"
                        [label]="'FORM.COMPANY_NAME' | translate"
                        [placeHolder]="'ABC Sdn Bhd'"
                        [controlName]="'companyName'"
                        [errors]="
                            getErrors(
                                'companyName',
                                'FORM.COMPANY_NAME' | translate
                            )
                        "
                    ></input-general>
                    <input-general
                        class="tw-block tw-mt-[20px] tw-w-[100%]"
                        [label]="'PROFILE.REFER.CODE_LABEL' | translate"
                        [placeHolder]="'ABC123'"
                        [controlName]="'referral'"
                        [errors]="
                            getErrors(
                                'referral',
                                'PROFILE.REFER.CODE_LABEL' | translate
                            )
                        "
                    ></input-general>
                    <div
                        class="tw-mt-10 tw-flex tw-gap-[1rem] tw-items-start lg:tw-items-center"
                    >
                        <input
                            type="checkbox"
                            class="tw-min-h-[18px] tw-border-gray-400 tw-bg-red-700 tw-border-[1px] tw-min-w-[18px] tw-cursor-pointer"
                            formControlName="acceptTerms"
                            (click)="onAcceptTerms($event)"
                        />
                        <div class="tw-text-gray-500">
                            {{ "REGISTER.REGISTER_SUBMIT_MESSAGE" | translate }}
                            <a
                                *ngIf="selectedLanguage == 'bm'"
                                href="/assets/documents/Polisi Privasi(BM).pdf"
                                alt="Image description"
                                target="_blank"
                            >
                                <span class="tw-underline">{{
                                    "COMMON.PRIVACY_NOTICE" | translate
                                }}</span>
                            </a>
                            <a
                                *ngIf="selectedLanguage == 'en'"
                                href="/assets/documents/Privacy & Security Policies.pdf"
                                alt="Image description"
                                target="_blank"
                            >
                                <span class="tw-underline">{{
                                    "COMMON.PRIVACY_NOTICE" | translate
                                }}</span>
                            </a>
                            {{ "COMMON.AND" | translate }}
                            <a
                                *ngIf="selectedLanguage == 'bm'"
                                href="/assets/documents/Terma Penggunaan(BM).pdf"
                                alt="Image description"
                                target="_blank"
                            >
                                <span class="tw-underline">{{
                                    "COMMON.TERMS_OF_USE" | translate
                                }}</span>
                            </a>
                            <a
                                *ngIf="selectedLanguage == 'en'"
                                href="/assets/documents/Terms of Use (EN).pdf"
                                alt="Image description"
                                target="_blank"
                            >
                                <span class="tw-underline">{{
                                    "COMMON.TERMS_OF_USE" | translate
                                }}</span> </a
                            >.
                        </div>
                    </div>
                    <div
                        *ngIf="
                            (f.acceptTerms.touched || submitted) &&
                            f.acceptTerms.errors
                        "
                        class="tw-mt-2 tw-text-[16px] tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-[#7B7575]"
                    >
                        <mat-icon class="error-icon !tw-overflow-visible"
                            >close</mat-icon
                        >
                        <span
                            *ngIf="f.acceptTerms.errors.required"
                            class="tw-w-full"
                        >
                            {{ "REGISTER.ACCEPT_TERMS_CONDITIONS" | translate }}
                        </span>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col tw-gap-4 tw-mt-6">
                    <button
                        ga-event-id="signup_continue_sp_click"
                        ga-event-category="Sign Up Page Button"
                        [attr.ga-event-label]="
                            JSON.stringify({
                                label: 'Sign Up Continue Button',
                                username: signUpForm.value.username,
                                email: signUpForm.value.email,
                                phoneNumber: signUpForm.value.phoneNumber
                            })
                        "
                        ga-track="track"
                        class="tw-rounded-[32px] tw-text-white tw-font-bold tw-h-[56px] tw-w-full tw-text-[16px]"
                        [ngClass]="
                            signUpForm.invalid
                                ? 'tw-bg-[#FFA53C] tw-opacity-50'
                                : 'tw-bg-[#FFA53C]'
                        "
                        type="submit"
                    >
                        {{ "COMMON.CONTINUE" | translate }}
                    </button>
                    <div
                        class="tw-flex tw-flex-col tw-items-center tw-text-[#7B7575]"
                    >
                        <div
                            ga-event-id="login_btm_button_sp_click"
                            ga-event-category="Sign Up Page Button"
                            ga-event-label="Login Bottom Button"
                            ga-track="track"
                            class="tw-underline tw-cursor-pointer"
                            (click)="onSignIn()"
                        >
                            {{ "COMMON.LOGIN" | translate }}
                        </div>
                    </div>
                    <div class="tw-mx-2">
                        <p
                            class="tw-text-[12px] tw-text-[#7B7575] tw-font-bold tw-inline tw-leading-3"
                        >
                            {{ "REGISTER.NOTE" | translate }}
                        </p>
                        <p
                            class="tw-text-[12px] tw-text-[#7B7575] tw-inline tw-leading-3"
                        >
                            {{ "REGISTER.DISCLAIMER" | translate }}
                        </p>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <img
        class="tw-hidden sm:tw-block tw-w-[85%] lg:tw-h-[30%] xl:tw-h-[60%] tw-fixed tw-left-0 tw-bottom-0 tw-z-[1]"
        src="../../../../assets/images/login-signup/Blue.png"
        alt="Blue Img"
    />
</div>
